import { Skeleton } from '@/components/ui/skeleton.component';

interface SlotsSkeletonProps {
  variant?: 'card' | 'modal';
  columns?: number;
}

const DEFAULT_MODAL_COLUMNS = 3;
const MODAL_SLOTS_PER_COLUMN = 4;

export function SlotsSkeleton({ variant = 'card', columns = DEFAULT_MODAL_COLUMNS }: SlotsSkeletonProps) {
  if (variant === 'card') {
    return (
      <div className="flex flex-col gap-2" role="status" aria-label="Carregando horários">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-10 w-full" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3" role="status" aria-label="Carregando horários">
      <div className="flex gap-4">
        {Array.from({ length: columns }).map((_, colIdx) => (
          <div key={colIdx} className="flex flex-1 flex-col gap-2 items-center">
            <Skeleton className="h-4 w-12" />
            <Skeleton className="h-5 w-10" />
            {Array.from({ length: MODAL_SLOTS_PER_COLUMN }).map((__, rowIdx) => (
              <Skeleton key={rowIdx} className="h-9 w-full" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
